<div class="storeFinder-wrapper">
  <router-outlet></router-outlet>
  <boels-store-finder-region></boels-store-finder-region>
</div>
